import { useTranslation } from 'react-i18next'
import { getGridNumbers, isNumberActive } from '../../utils'
import { BetTypeEnum, DigitMode, LottoBetList } from '../../../BetLotto.types'
import { GetLimitTypeUIHandler } from '../../PanelSelection.types'
import { renderGridItemClasses } from './SelectBetNumber.utils'

interface SelectBetNumberProps {
  digitMode: DigitMode
  selectedRange?: string
  searchQuery: string
  betList?: LottoBetList[]
  onSelectBetNumber: (number: string) => void
  isDisabled: boolean
  getLimitTypeUI: GetLimitTypeUIHandler
  activeBetType: BetTypeEnum[]
}

const SelectBetNumber: React.FC<SelectBetNumberProps> = ({
  digitMode,
  selectedRange,
  searchQuery,
  betList,
  onSelectBetNumber,
  isDisabled,
  getLimitTypeUI,
  activeBetType,
}) => {
  const { t } = useTranslation()

  return (
    <div>
      <h5 className="text-[var(--caption-text)] text-base font-medium mb-4 text-left">
        {t('betDetailPanel.selectBetNumber')}
      </h5>
      <div className="grid grid-cols-5 md:grid-cols-5 lg:grid-cols-10 gap-3 mb-6">
        {getGridNumbers(digitMode, selectedRange, searchQuery).map((num) => {
          const isActive = isNumberActive(num, betList ?? [])
          const limitResult = getLimitTypeUI(num, activeBetType)
          const limitStatus = limitResult.limit
          return (
            <button
              type="button"
              key={num}
              onClick={() => onSelectBetNumber(num)}
              className={`${renderGridItemClasses(
                isDisabled,
                isActive,
                limitStatus,
              )} rounded-lg`}
            >
              {num}
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default SelectBetNumber
